import sessionTimer from './sessionTimer';

$(document).ajaxComplete((event, xhr) => {
    if (xhr.responseJSON?.timeout) {
        sessionTimer.resetAfterAjaxSuccess(Date.now(), xhr.responseJSON.timeout);
    }
});